import React from "react"
import PropTypes from "prop-types"

import { AtlasContext } from "../../components/atlas-context"
import Caption from "../../components/caption"

import atomPhoton from "../../assets/videos/atom_photon.mp4"
import teaser from "../../assets/images/photon_preview.png"

const meta = {
    title: "AtomPhoton",
    creator: "Emily Edwards",
    type: "video",
    caption:
        "An atom can gain energy by absorbing a photon. Later, it can give up that energy by emitting a photon.",
    teaserImage: teaser,
    published: true,
    keywords: ["atoms", "photons", "animation"],
}

class AtomPhoton extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div id="atom-photon-video">
                <div style={{ marginTop: "0.5rem", marginBottom: "1rem" }}>
                    <video
                        style={{ width: "100%" }}
                        src={atomPhoton}
                        autoPlay={true}
                        muted=""
                        playsInline=""
                        preload="auto"
                        loop={true}
                        controls={true}
                    ></video>
                    <AtlasContext.Provider value="standalone">
                        <Caption
                            text={
                                meta.caption +
                                " (Animation inspired by [Quantum Made Simple](http://toutestquantique.fr/en/laser/))"
                            }
                        />
                    </AtlasContext.Provider>
                </div>
            </div>
        )
    }
}

AtomPhoton.propTypes = {
    classes: PropTypes.object,
}

export default AtomPhoton
export { meta }
